import { h, Component } from 'preact';
import { getSVGPriceChartURL, getPNGPriceChartURL } from '@os/cloudquote';
import cx from 'classnames';
import { Text } from 'preact-i18n';
import style from './style';
import { Select, Option } from '@cube/blocks';
import { FinanceSpinner } from '../glyphs';
import linkState from 'linkstate';

export const INTL_NS = 'stock-chart',
	INTERVAL_NS = `${INTL_NS}.intervals`,
	COMP_NS = `${INTL_NS}.comparisons`;


export class StockChartImage extends Component {
	isLoaded = () => {
		this.setState({ loaded: true });
	};

	constructor(props, context) {
		super(props, context);
		this.svg = document.implementation &&
		document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.symbol !== this.props.symbol) {
			this.setState({ loaded: false });
		}
	}

	render(props, { loaded = false }) {
		// NOTE: This image contains X-axis values that can't be localized
		let src = this.svg ? getSVGPriceChartURL(props) : getPNGPriceChartURL(props);

		return (
			<div class={cx(style['stock-chart'], !loaded && style.loading)}>
				{!loaded && (
					<FinanceSpinner class={style.spinner} />
				)}
				<img src={src} onload={this.isLoaded} />
			</div>
		);
	}
}

export const StockChartBare = (props, state) => (
	<div class={style['stock-chart']}>
		<StockChartImage {...props} />
	</div>
);

export class StockChartWithIntervals extends Component {
	intervals = [
		{ days: 1, label: <Text id={`${INTERVAL_NS}.oneDay`} /> },
		{ days: 7, label: <Text id={`${INTERVAL_NS}.oneWeek`} /> },
		{ days: 31, label: <Text id={`${INTERVAL_NS}.oneMonth`} /> },
		{ days: 92, label: <Text id={`${INTERVAL_NS}.threeMonth`} /> },
		{ days: 366, label: <Text id={`${INTERVAL_NS}.oneYear`} /> },
		{ days: 1830, label: <Text id={`${INTERVAL_NS}.fiveYear`} /> },
		{ days: 73000, label: <Text id={`${INTERVAL_NS}.max`} /> } // 200 years, defaults to max
	];

	comparisons = [
		{ label: <Text id={`${COMP_NS}.none`} />, symbol: null },
		{ label: <Text id={`${COMP_NS}.dow`} />, symbol: '$DJI' },
		{ label: <Text id={`${COMP_NS}.nasdaq`} />, symbol: '$COMP' },
		{ label: <Text id={`${COMP_NS}.sp500`} />, symbol: '$SPX' }
	];

	render({ symbol, ...props }, { curInterval=0, curComparison=0 }) {
		let interval = this.intervals[curInterval];
		let comparison = this.comparisons[curComparison];
		if (comparison.symbol) {
			symbol += ',' + comparison.symbol;
		}

		return (
			<div class={`${style['stock-chart-with-intervals']}`}>
				<StockChartImage interval={interval.days} symbol={symbol} {...props} />
				<div class={`${style.intervals} ${style['horizontal-nav']}`}>
					{ this.intervals.map( (interval, i) => (
						<StockChartButton
							onClick={linkState(this, 'curInterval', 'interval')}
							interval={i}
							active={i===curInterval}
							label={interval.label}
						/>
					)) }
				</div>
				<div class={style.comparisons}>
					<div class={style.inner}>
						<div class={style.title}>
							<span><Text id={`${INTL_NS}.compareTo`}>Compare to</Text></span>

							<Select anchor="right" iconPosition="right" value={curComparison} onChange={linkState(this, 'curComparison', 'value')}>
								{ this.comparisons.map( (item, i) => (
									<Option iconPosition="left" title={item.label} value={i} />
								)) }
							</Select>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export class StockChartButton extends Component {
	handleClick = () => {
		this.props.onClick(this.props);
	};

	render({ active, label }) {
		let activeStyle = active ? style.active : '';
		return (
			<span onClick={this.handleClick} class={`${activeStyle} ${style['interval-selector']}`}>
				{ label }
			</span>
		);
	}
}
